module.exports = __webpack_public_path__ + "img/ic_welcome.50434015.png";